<div class="pagination" [ngClass]="{'on-top': onTop}">
  <button mat-button color="primary" class="input-button icon-button small" (click)="pageChange.emit(page - 1)" [disabled]="page === 1">
    <mat-icon class="svg-icon" [svgIcon]="'arrow_left'"></mat-icon>
  </button>
  <ng-container *ngFor="let pageItem of pageItems">
    <button mat-button class="page-button small" [ngClass]="{'active': pageItem === page.toString(), 'delimiter': pageItem === '...'}"
            (click)="pageItem !== '...' ? pageChange.emit(+pageItem) : null" [disabled]="pageItem === '...'">
      {{pageItem}}
    </button>
  </ng-container>
  <button mat-button color="primary" class="input-button icon-button small" (click)="pageChange.emit(page + 1)" [disabled]="page === pagesTotal">
    <mat-icon class="svg-icon" [svgIcon]="'arrow_right'"></mat-icon>
  </button>
</div>
